import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

// routes
import AuthenticationRoutes from './AuthenticationRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import SimpleRoutes from './SimpleRoutes';
import ChatRoutes from './ChatRoutes';
import BrainRoutes from './BrainRoutes';
// project imports
import Loadable from 'ui-component/Loadable';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [{ path: '/', element: <Navigate to="/login" replace /> }, AuthenticationRoutes, LoginRoutes, SimpleRoutes, BrainRoutes, MainRoutes, ChatRoutes],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;
